import { FC, ReactElement, useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import CaretBtn from '~src/shared/buttons/caretBtn/CaretBtn';
import { TileContainer } from '~src/styles/containers.sc';

import { Header, CaretBox, ContentContainer } from './collapsibleListItem.sc';

interface DefaultProps {
  contentAnimationTimeout: number; // to disable animation pass 0
}

interface Props extends Partial<DefaultProps> {
  header: ReactElement;
  maxHeight?: number;
  isOpen?: boolean;
  marginTop?: number;
  onHeaderClick?(): void;
}

const caretSize = 18;

const CollapsibleListItem: FC<Props> = props => {
  const { contentAnimationTimeout = 500 } = props;
  const [isContentVisible, setIsContentVisible] = useState(props.isOpen);
  const [maxHeight, setMaxHeight] = useState(props.maxHeight);
  const contentElRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setIsContentVisible(props.isOpen);
  }, [props.isOpen]);

  const toggleContent = () => {
    if (props.onHeaderClick) {
      props.onHeaderClick();
    }
    setIsContentVisible(isVisible => {
      if (!isVisible) {
        setTimeout(getContentHeight, contentAnimationTimeout);
      }
      return !isVisible;
    });
  };

  const getContentHeight = () => {
    if (contentElRef.current) {
      const containerHeight = contentElRef.current.clientHeight;
      const contentNode = contentElRef.current.firstChild as HTMLDivElement | null;
      if (contentNode && containerHeight < contentNode.clientHeight) {
        setMaxHeight(contentNode.clientHeight);
      }
    }
  };

  return (
    <TileContainer $marginTop={props.marginTop}>
      <Header onClick={toggleContent} $caretSize={caretSize}>
        {props.header}
        <CaretBox>
          <CaretBtn withContainer open={isContentVisible} size={`${caretSize}px`} />
        </CaretBox>
      </Header>
      <CSSTransition
        in={isContentVisible}
        timeout={contentAnimationTimeout}
        mountOnEnter
        unmountOnExit
        appear
      >
        <ContentContainer ref={contentElRef} $timeout={contentAnimationTimeout} $maxHeight={maxHeight}>
          {props.children}
        </ContentContainer>
      </CSSTransition>
    </TileContainer>
  );
};
export default CollapsibleListItem;
